// ONE type scale for cards, rows, tiles, chips and section labels (Launchpad, table strips,
// Reporting). Dependency-free so lightweight widgets (and tests that stub MUI) can import it
// without pulling in ActionCards. Colours are theme tokens (text.primary / text.secondary /
// text.disabled) — no hard-coded greys — and no text in these components uses lineHeight 1 / 1.1.

// Section label above a Launchpad row ("Needs you today", "This month", …).
export const SECTION_LABEL = {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '16px',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'text.secondary',
};

// Card header row label (dot + label).
export const CARD_LABEL = {
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'text.secondary',
};

// Back-compat alias — the Reporting cards import this name.
export const CARD_LABEL_SX = CARD_LABEL;

export const CARD_NUMBER = {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.15,
    color: 'text.primary',
};

export const CHIP = {
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '16px',
    padding: '3px 8px',
    borderRadius: '10px',
};

export const ROW_PRIMARY = {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
    color: 'text.primary',
};

export const ROW_SECONDARY = {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '17px',
    color: 'text.secondary',
};

// Tertiary text at the right of a row (time chip text, status, "Overdue by N days").
export const ROW_META = {
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '16px',
    color: 'text.disabled',
};

// Small inner tiles (StatCard size="sm").
export const TILE_LABEL = {
    fontSize: '10px',
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'text.secondary',
};

export const TILE_NUMBER = {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.2,
    color: 'text.primary',
};

// Spacing tokens that go with the scale.
export const CARD_DOT_SIZE = 6;
export const CARD_LABEL_GAP = '8px'; // dot → label
export const HEADER_NUMBER_GAP = '8px'; // header row → number
export const NUMBER_CHIPS_GAP = '10px'; // number → chips
export const CHIP_GAP = '6px'; // between chips
export const CHIP_DOT_SIZE = 6;
export const CHIP_DOT_GAP = '6px';
export const ROW_MIN_HEIGHT = 48;
export const ROW_GAP = '12px';
export const ROW_LINE_GAP = '2px'; // primary → secondary
export const TILE_PADDING = '10px 12px';
